module.exports = __webpack_public_path__ + "img/cloud_google.9c3c0ad3.png";